// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1hbgh","legacyBtn":"MutateMid_legacyBtn__86yJ-"};